import { useState } from 'react'
import { useAuth } from '../../contexts/AuthContext'
import { usePublicSettings } from '../../hooks/usePublicSettings'
import { ErrorNote, SubmitButton, INPUT } from './AuthLayout'

/**
 * "Set a password" after a WhatsApp-code sign-in (the server allows it for a short time after the code:
 * setting security.customer_set_password_minutes). Customers without an email add one: it is what they
 * sign in with. Rules: security.password_min_length.
 */
export default function SetPasswordForm({ needsEmail, onDone }) {
  const { setPassword } = useAuth()
  const settings = usePublicSettings()
  const minPassword = settings?.['security.password_min_length']
  const [email, setEmail] = useState('')
  const [password, setPw] = useState('')
  const [confirm, setConfirm] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError(null)
    if (minPassword && password.length < minPassword) { setError(`Password must be at least ${minPassword} characters long`); return }
    if (password !== confirm) { setError('Passwords do not match'); return }
    setLoading(true)
    const r = await setPassword({ password, email: needsEmail ? email.trim() : undefined })
    setLoading(false)
    if (r.success) onDone?.(r)
    else setError(r.error)
  }

  return (
    <>
      <ErrorNote>{error}</ErrorNote>
      <form onSubmit={handleSubmit} className="space-y-4" aria-label="Set a password">
        {needsEmail && (
          <div>
            <label htmlFor="sp-email" className="block text-sm font-medium text-slate-700 mb-1">Email</label>
            <input id="sp-email" type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className={INPUT} placeholder="You'll sign in with this" required />
          </div>
        )}
        <div>
          <label htmlFor="sp-password" className="block text-sm font-medium text-slate-700 mb-1">New password</label>
          <input id="sp-password" type="password" autoComplete="new-password" value={password} onChange={(e) => setPw(e.target.value)}
            className={INPUT} placeholder={minPassword ? `At least ${minPassword} characters` : 'New password'}
            minLength={minPassword || undefined} required />
        </div>
        <div>
          <label htmlFor="sp-confirm" className="block text-sm font-medium text-slate-700 mb-1">Confirm password</label>
          <input id="sp-confirm" type="password" autoComplete="new-password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
            className={INPUT} placeholder="Type it again" required />
        </div>
        <SubmitButton loading={loading} busyText="Saving…">Set password</SubmitButton>
      </form>
    </>
  )
}
